"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.postESSData = exports.submitData = exports.getData = exports.HttpError = void 0;
var fetchUtils_1 = require("./fetchUtils");
var atoz_shiftapp_metrics_1 = require("@amzn/atoz-shiftapp-metrics");
var HttpError = /** @class */ (function (_super) {
    __extends(HttpError, _super);
    function HttpError(statusCode, message) {
        var _this = _super.call(this) || this;
        _this.statusCode = statusCode;
        _this.message = message;
        return _this;
    }
    return HttpError;
}(Error));
exports.HttpError = HttpError;
/**
 * Use this method for fetching (GET) data to AtoZ API delegator vended endpoint, i.e:
 * https://atoz-api.integ.amazon.com or https://atoz-api.amazon.work
 */
var getData = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, fetch("".concat(fetchUtils_1.host).concat(params.path), {
                    method: 'GET',
                    headers: (0, fetchUtils_1.getApiGatewayHeaders)(fetchUtils_1.currentStage, fetchUtils_1.AtoZClientId.TIME_OFF),
                    credentials: (0, fetchUtils_1.getCredentials)(fetchUtils_1.currentStage)
                })];
            case 1:
                response = _c.sent();
                if (!!response.ok) return [3 /*break*/, 3];
                _a = HttpError.bind;
                _b = [void 0, response.status];
                return [4 /*yield*/, response.text()];
            case 2: 
            // TODO: emit a metric for HTTP error
            throw new (_a.apply(HttpError, _b.concat([_c.sent()])))();
            case 3: return [2 /*return*/, response.json()];
        }
    });
}); };
exports.getData = getData;
/**
 * Use this method for posting data to AtoZ API delegator vended endpoint, i.e:
 * https://atoz-api.integ.amazon.com or https://atoz-api.amazon.work
 */
var submitData = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, fetch("".concat(fetchUtils_1.host).concat(params.path), {
                    method: params.method,
                    headers: (0, fetchUtils_1.getApiGatewayHeaders)(fetchUtils_1.currentStage, fetchUtils_1.AtoZClientId.TIME_OFF),
                    credentials: (0, fetchUtils_1.getCredentials)(fetchUtils_1.currentStage),
                    body: JSON.stringify(params.body)
                })];
            case 1:
                response = _c.sent();
                logHttpResponse(params.method, response.clone(), params.useTaaDashboardComponents);
                if (!!response.ok) return [3 /*break*/, 3];
                _a = HttpError.bind;
                _b = [void 0, response.status];
                return [4 /*yield*/, response.text()];
            case 2: 
            // TODO: emit a metric for HTTP error
            throw new (_a.apply(HttpError, _b.concat([_c.sent()])))();
            case 3: return [2 /*return*/, response.json()];
        }
    });
}); };
exports.submitData = submitData;
/**
 * Use this method for posting data to ESS portal vended endpoint,
 * the endpoints which are served by controllers from the ESS portal codebase
 * i.e. https://essportal.integ.amazon.com/
 */
var postESSData = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var method, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                method = 'POST';
                return [4 /*yield*/, fetch(params.path, {
                        method: method,
                        headers: (0, fetchUtils_1.getEsspHeaders)(),
                        credentials: (0, fetchUtils_1.getCredentials)(fetchUtils_1.currentStage),
                        body: JSON.stringify(params.body)
                    })];
            case 1:
                response = _a.sent();
                logHttpResponse(method, response.clone(), params.useTaaDashboardComponents);
                if (!response.ok) {
                    // TODO: Throw a dedicated HTTP error and also emit a metric
                    throw new Error();
                }
                return [2 /*return*/, response];
        }
    });
}); };
exports.postESSData = postESSData;
/**
 * Log HTTP Response/Error to Katal Logger
 */
var logHttpResponse = function (method, response, useTaaDashboardComponents) { return __awaiter(void 0, void 0, void 0, function () {
    var basicLogContext, message, _a, _b, _c, _d;
    var _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                basicLogContext = {
                    method: method || '',
                    url: response.url,
                    statusCode: response.status,
                    useTaaDashboardComponents: useTaaDashboardComponents
                };
                message = "TaaHttpRequest.".concat(response.ok ? 'Response' : 'Error');
                if (!!response.ok) return [3 /*break*/, 2];
                _b = (_a = atoz_shiftapp_metrics_1.logger).error;
                _c = [message];
                _d = [__assign({}, basicLogContext)];
                _e = {};
                return [4 /*yield*/, response.text()];
            case 1:
                _b.apply(_a, _c.concat([__assign.apply(void 0, _d.concat([(_e.data = _f.sent(), _e)]))]));
                return [3 /*break*/, 3];
            case 2:
                atoz_shiftapp_metrics_1.logger.info(message, basicLogContext);
                _f.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}); };
